import {
    Component,
    EventEmitter,
    Input,
    Output,
    SimpleChange,
} from '@angular/core';

@Component({
    selector: 'app-password-stength',
    templateUrl: './password-stength.component.html',
    styleUrls: ['./password-stength.component.scss'],
})
export class PasswordStengthComponent {
    @Input() public passwordToCheck: string;
    @Output() passwordStrength = new EventEmitter<boolean>();
    bar0: string;
    bar1: string;
    bar2: string;
    bar3: string;
    msg = '';

    ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
        const password: any = changes.passwordToCheck.currentValue;
        if (password) {
            if (password.length === 8) {
                this.msg = 'POOR';
                this.bar0 = 'red';
                this.bar1 = 'grey';
                this.bar2 = 'grey';
                this.bar3 = 'grey';
            } else if (password.length > 8 && password.length <= 11) {
                this.msg = 'FINE';
                this.bar0 = 'red';
                this.bar1 = 'red';
                this.bar2 = 'grey';
                this.bar3 = 'grey';
            } else if (password.length > 11 && password.length <= 14) {
                this.msg = 'GOOD';
                this.bar0 = 'blue';
                this.bar1 = 'blue';
                this.bar2 = 'blue';
                this.bar3 = 'grey';
            } else if (password.length > 14 && password.length <= 16) {
                this.msg = 'STRONG';
                this.bar0 = 'blue';
                this.bar1 = 'blue';
                this.bar2 = 'blue';
                this.bar3 = 'blue';
            }
        }
    }
}
